var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMileage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7577_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5M16.5 9H14.625M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5M1.5 9H3.375M9 1.5V3.375M14.3088 3.75L10.1249 7.875M14.3088 14.3088L14.1559 14.1559C13.637 13.637 13.3776 13.3776 13.0749 13.1921C12.8064 13.0276 12.5138 12.9064 12.2077 12.8329C11.8624 12.75 11.4955 12.75 10.7618 12.75L7.23822 12.75C6.50445 12.75 6.13756 12.75 5.7923 12.8329C5.4862 12.9064 5.19356 13.0276 4.92515 13.1921C4.6224 13.3776 4.36297 13.6371 3.84412 14.1559L3.69122 14.3088M3.69122 3.75L4.99356 5.05234M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7577_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/mileage.e8f9cf457ec9829fae88650a547bbfda.svg";
export { ForwardRef as ReactComponent };